import { Box } from '@mui/material';
import { AppLayout } from '../components/AppLayout';
import { AppHeader } from '../components/AppHeader';
import { AppFooter } from '../components/AppFooter';
import { ParticipantStatus } from '../components/ParticipantStatus';

export interface ParticipantHomeProps {
  userName?: string;
}

/**
 * ParticipantHome - Post-join landing page for active participants
 *
 * Implements Story 2.7 requirements:
 * - Shows calm, minimal post-join state
 * - No admin or programme-owner surfaces
 * - No metrics or status indicators beyond "You may be matched"
 * - Default role is participant only
 *
 * What NOT to show (per story requirements):
 * - Participation counts or metrics
 * - Admin controls or configuration
 * - Engagement indicators
 * - Leaderboards, streaks, or gamification
 * - Programme owner visibility
 */
export function ParticipantHome({ userName }: ParticipantHomeProps) {
  return (
    <AppLayout header={<AppHeader userName={userName} />} footer={<AppFooter />}>
      <Box sx={{ py: 4 }}>
        <ParticipantStatus />
      </Box>
    </AppLayout>
  );
}
